export { default as ACM } from './team-icons/ACM_onboard.webp';
export { default as alayanspor } from './team-icons/alayanspor_onboard.webp';
export { default as AlfaRomeo } from './team-icons/Alfa_Romeo_onboard.webp';
export { default as alliance } from './team-icons/alliance_onboard.webp';
export { default as argentina } from './team-icons/argentina_onboard.webp';
export { default as Arsenal } from './team-icons/Arsenal_onboard.webp';
export { default as ASRoma } from './team-icons/AS_Roma_onboard.webp';
export { default as AstonMartin } from './team-icons/Aston_Martin_onboard.webp';
export { default as atletico } from './team-icons/atletico_onboard.webp';
export { default as Barcelona } from './team-icons/Barcelona_onboard.webp';
export { default as benfica } from './team-icons/benfica_onboard.webp';
export { default as Cam } from './team-icons/Cam_onboard.webp';
export { default as clubDeportivoGuadalajara } from './team-icons/club_deportivo_guadalajara_onboard.webp';
export { default as corinthians } from './team-icons/corinthians_onboard.webp';
export { default as davisCup } from './team-icons/davis_cup_onboard.webp';
export { default as ENDCEX } from './team-icons/ENDCEX_onboard.webp';
export { default as flemengo } from './team-icons/flemengo_onboard.webp';
export { default as Galatasary } from './team-icons/Galatasary_onboard.webp';
export { default as harlequin } from './team-icons/harlequin_onboard.webp';
export { default as hereditic } from './team-icons/hereditic_onboard.webp';
export { default as interMilan } from './team-icons/inter_milan_onboard.webp';
export { default as johor } from './team-icons/johor_onboard.webp';
export { default as juventus } from './team-icons/juventus_onboard.webp';
export { default as leeds } from './team-icons/leeds_onboard.webp';
export { default as leicesterTigers } from './team-icons/leicester-tigers_onboard.webp';
export { default as manchesterCity } from './team-icons/manchester_city_onboard.webp';
export { default as mibr } from './team-icons/mibr_onboard.webp';
export { default as napoli } from './team-icons/napoli_onboard.webp';
export { default as navi } from './team-icons/navi_onboard.webp';
export { default as og } from './team-icons/og_onboard.webp';
export { default as PFL } from './team-icons/PFL_onboard.webp';
export { default as plameras } from './team-icons/plameras_onboard.webp';
export { default as psg } from './team-icons/psg_onboard.webp';
export { default as RFK } from './team-icons/RFK_onboard.webp';
export { default as RiverPlate } from './team-icons/River_plate_onboard.webp';
export { default as saracens } from './team-icons/saracens_onboard.webp';
export { default as SFParis } from './team-icons/SF_Paris_onboard.webp';
export { default as sharks } from './team-icons/sharks_onboard.webp';
export { default as SPFC } from './team-icons/SPFC_onboard.webp';
export { default as Trrabzonspor } from './team-icons/Trrabzonspor_onboard.webp';
export { default as UFC } from './team-icons/UFC_onboard.webp';
export { default as valencia } from './team-icons/valencia_onboard.webp';
export { default as vitality } from './team-icons/vitality_onboard.webp';
